import { Box, Grid, makeStyles, Typography } from '@material-ui/core';
import { colors } from 'design-system';

const useStyle = makeStyles(() => ({
  descriptionText: {
    fontSize: 15,
    fontWeight: 500,
    textAlign: 'left',
    maxWidth: '180px',
  },
  valueText: {
    color: colors.abbey,
    fontSize: 15,
    fontWeight: 400,
    textAlign: 'right',
  },
  helperText: {
    color: '#A3A2A2',
    fontSize: 13,
    fontWeight: 400,
    textAlign: 'right',
  },
  textGray: {
    color: colors.abbey,
    fontSize: 15,
    fontWeight: 400,
  },
  rowContainer: {
    marginBottom: 15,
  },
  tooltipRoot: {
    maxWidth: 130,
    color: colors.madison,
    backgroundColor: 'white',
    fontSize: 13,
    fontWeigh: 500,
    border: '1px solid #00',
    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.05)',
  },
  tooltipArrow: {
    color: 'white',
  },
}));

type Props = {
  description: string;
  value: string;
  showHelper: boolean;
  helperText: string;
};

const DeductibleDetailRow = ({
  description,
  value,
  helperText,
  showHelper,
}: Props): JSX.Element => {
  const classes = useStyle();
  return (
    <Grid item className={classes.rowContainer} data-testid="information-row">
      <Grid container justifyContent="space-between" alignItems="baseline">
        <Grid item xs={12}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography
              data-testid="description-text"
              display="block"
              className={classes.descriptionText}
            >
              {description}
            </Typography>
            <Box
              display="flex"
              justifyContent="flex-end"
              flexDirection="column"
            >
              <Box display="flex" justifyContent="flex-end">
                <Typography
                  className={classes.valueText}
                  data-testid="value-text"
                >
                  {value}
                </Typography>
              </Box>
              {showHelper && (
                <Box display="flex" justifyContent="flex-end">
                  <Typography
                    data-testid="value-text"
                    className={classes.helperText}
                  >
                    {helperText}
                  </Typography>
                </Box>
              )}
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default DeductibleDetailRow;
